import { ComponentType } from "react"
import { Box, SxProps } from "@mui/material"
import SimpleBar from "simplebar-react"

import { Feature } from "geojson"
import { Id } from "@turf/helpers"
import { IVerticalCardProps, VerticalCard } from "components/card/VerticalCard"

interface IBaseCardProps<TData = Feature> {
  className?: string
  data: TData
}
export interface IFeatureGridLayoutProps<
  P extends object = {},
  TData extends Feature = Feature
> {
  sx?: SxProps
  features: Feature[]
  onClickCard?: (id: Id) => void
  cardComponent?: ComponentType<IBaseCardProps<TData> & P>
  cardProps?: P
}

export const FeatureGridLayout = <
  P extends IVerticalCardProps = IVerticalCardProps,
  TData extends Feature = Feature
>({
  sx,
  features,
  onClickCard = () => {},
  cardComponent: CardComponent = VerticalCard,
  cardProps,
}: IFeatureGridLayoutProps<P>) => {
  return (
    <SimpleBar
      style={{
        width: "100%",
        height: "100%",
        overflow: "hidden auto",
      }}
    >
      <Box sx={sx}>
        {features.map((feature) => {
          const sponsoredId = feature?.properties?.sponsoredId

          return (
            <Box
              onClick={() => onClickCard(feature.id)}
              key={`${sponsoredId || ""}${feature.id}`}
            >
              <CardComponent
                className="FeatureGridLayout"
                data={feature as TData}
                {...(cardProps ?? ({} as P))}
              />
            </Box>
          )
        })}
      </Box>
    </SimpleBar>
  )
}
